
import { Component, inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { interval, Subscription } from 'rxjs';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { Router, ActivatedRoute, Params } from '@angular/router';



registerLocaleData(localeEn); // English locale
registerLocaleData(localeEs); // Spanish locale

@Component({
  selector: 'afcu-header',
  standalone: true,
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'en' }],
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent extends BaseConfigurableComponent implements OnInit, OnDestroy{
  currentTime: string = ''
  private timeSubscription!: Subscription
  
  protected schedulerService = inject( SchedulerStepService );

  constructor(private datePipe: DatePipe, private router: Router, private activeRoute: ActivatedRoute){
    super('header')
    this.getOrigin()
  }

  get activeRedirect(): boolean {
    return this.router.url.includes('/splash') ||  this.router.url === '/configuration' || this.router.url.includes('/your-appointment') ||  this.router.url.includes('?origin=kiosk') || this.router.url.includes('?origin=queue') ;
  }
  


  ngOnInit(): void {
    this.updateTime()
    this.timeSubscription = interval(1000).subscribe(() => {
      this.updateTime()
    })
  }

  updateTime() {
    const now = new Date();
    this.currentTime = this.datePipe.transform(now, 'EEEE, MMMM d, y h:mm a', undefined, this.textService.language()) || '';
  }

  ngOnDestroy(): void {
    if(this.timeSubscription)
      this.timeSubscription.unsubscribe()
  }

}